
const imageUrls = {
    monitor: './images/Monitor.svg',
    monitor1: './images/Monitor1.svg',
    monitor2: './images/Monitor2.svg',
  };
  
  export default imageUrls;